import React from 'react';
import styled from 'styled-components';

type Props = {
  children: React.ReactNode,
};

const Title = ({children}: Props) => <Container>{children}</Container>;

export default Title;

const Container = styled.div`
  padding-top: 40px;
  margin-bottom: 50px;
  font-size: 30px;
  letter-spacing: 0.5px;
  text-align: center;
  color: #616161;
`;
